import { Skeleton } from '@/components/ui/Skeleton.tsx';

const MarkAsPaidModalSkeleton = () => {
  return (
    <div className="space-y-4">
      <Skeleton className="h-4 w-72" />

      <div className="space-y-2">
        <div className="flex justify-between border-b border-neutral-100 py-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-24" />
        </div>
        <div className="flex justify-between border-b border-neutral-100 py-2">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-4 w-20" />
        </div>
      </div>

      <div className="flex items-center gap-2 py-2">
        <Skeleton className="h-4 w-4 rounded-[3px]" />
        <Skeleton className="h-4 w-36" />
      </div>
    </div>
  );
};

export default MarkAsPaidModalSkeleton;
